import {constants} from '@neosvoc/nv-platform-core-common';
import messages from '../../res/translations/messages';

const pageBuilders = {
    [constants.EDITOR_TEMPLATES.STRING_1]: (nextPageId, nextId) => ({
        id: nextPageId(), preScripts: [], postScripts: [], optionsScripts: [], rowsScripts: [], terminal: false,
        items: [{type: constants.EDITOR_TEMPLATES.STRING_1, id: nextId(), required: true, title: '', subtitle: '', multiline: false,
            sentimentAnalysis: false, entityExtraction: false}],
    }),


    [constants.EDITOR_TEMPLATES.TEXT_1]: (nextPageId, nextId) => ({
        id: nextPageId(), preScripts: [], postScripts: [], optionsScripts: [], rowsScripts: [], terminal: false,
        items: [{type: constants.EDITOR_TEMPLATES.TEXT_1, text: '', subtitle: '', linkUrl: '', linkLabel: '', redirectTimeout: 5}],
    }),


    [constants.EDITOR_TEMPLATES.NUMBER_1]: (nextPageId, nextId) => ({
        id: nextPageId(), preScripts: [], postScripts: [], optionsScripts: [], rowsScripts: [], terminal: false,
        items: [{type: constants.EDITOR_TEMPLATES.NUMBER_1, id: nextId(), required: true, title: '', subtitle: '', min: '', max: ''}],
    }),
    [constants.EDITOR_TEMPLATES.NUMBER_2]: (nextPageId, nextId) => ({
        id: nextPageId(), preScripts: [], postScripts: [], optionsScripts: [], rowsScripts: [], terminal: false,
        items: [{type: constants.EDITOR_TEMPLATES.NUMBER_2, id: nextId(),
            title: '', subtitle: '', required: true, min: '', max: '', minLabel: '', maxLabel: '', step: '', interval: '',
            nps: false, exclusiveChoiceEnabled: false, componentType: 'slider', rangesColors: []}],
    }),
    [constants.EDITOR_TEMPLATES.NUMBER_3]: (nextPageId, nextId) => ({
        id: nextPageId(), preScripts: [], postScripts: [], optionsScripts: [], rowsScripts: [], terminal: false,
        items: [{type: constants.EDITOR_TEMPLATES.NUMBER_2, id: nextId(),
            title: '', subtitle: '', required: true, min: 1, max: 10, minLabel: '', maxLabel: '', step: 1, interval: 1,
            nps: false, exclusiveChoiceEnabled: false, componentType: 'rating', rangesColors: []}],
    }),


    [constants.EDITOR_TEMPLATES.MULTIPLE_NUMBER_1]: (nextPageId, nextId) => ({
        id: nextPageId(), preScripts: [], postScripts: [], optionsScripts: [], rowsScripts: [], terminal: false,
        items: [{
            type: constants.EDITOR_TEMPLATES.MULTIPLE_NUMBER_1, id: nextId(), title: '', subtitle: '', required: true,
            min: '', max: '', preset: '', rows: [], step: 1,
        }],
    }),
    [constants.EDITOR_TEMPLATES.MULTIPLE_NUMBER_2]: (nextPageId, nextId) => ({
        id: nextPageId(), preScripts: [], postScripts: [], optionsScripts: [], rowsScripts: [], terminal: false,
        items: [{type: constants.EDITOR_TEMPLATES.MULTIPLE_NUMBER_2, id: nextId(),
            title: '', subtitle: '', required: true, min: '', max: '', minLabel: '', componentType: 'slider',
            rangesColors: [], maxLabel: '', rows: [], step: 1, interval: 1,
            exclusiveChoiceEnabled: false}],
    }),
    [constants.EDITOR_TEMPLATES.MULTIPLE_NUMBER_3]: (nextPageId, nextId) => ({
        id: nextPageId(), preScripts: [], postScripts: [], rowsScripts: [], terminal: false,
        items: [{type: constants.EDITOR_TEMPLATES.MULTIPLE_NUMBER_3, id: nextId(), title: '', subtitle: '', required: true, max: '', rows: []}],
    }),
    [constants.EDITOR_TEMPLATES.MULTIPLE_NUMBER_4]: (nextPageId, nextId) => ({
        id: nextPageId(), preScripts: [], postScripts: [], optionsScripts: [], rowsScripts: [], terminal: false,
        items: [{type: constants.EDITOR_TEMPLATES.MULTIPLE_NUMBER_2, id: nextId(),
            title: '', subtitle: '', required: true, min: 1, max: 10, minLabel: '', componentType: 'rating', rangesColors: [], maxLabel: '', rows: [],
            step: 1, interval: 1,
            exclusiveChoiceEnabled: false}],
    }),


    [constants.EDITOR_TEMPLATES.RANK_1]: (nextPageId, nextId) => ({
        id: nextPageId(), preScripts: [], postScripts: [], rowsScripts: [], terminal: false,
        items: [{type: constants.EDITOR_TEMPLATES.RANK_1, id: nextId(), title: '', subtitle: '', rows: [], min: '', max: ''}],
    }),


    [constants.EDITOR_TEMPLATES.SINGLE_CHOICE_1]: (nextPageId, nextId) => ({
        id: nextPageId(), preScripts: [], postScripts: [], optionsScripts: [], rowsScripts: [], terminal: false,
        items: [{type: constants.EDITOR_TEMPLATES.SINGLE_CHOICE_1, id: nextId(), title: '', subtitle: '', required: true, choices: []}],
    }),
    [constants.EDITOR_TEMPLATES.SINGLE_CHOICE_2]: (nextPageId, nextId) => ({
        id: nextPageId(), preScripts: [], postScripts: [], optionsScripts: [], rowsScripts: [], terminal: false,
        items: [{type: constants.EDITOR_TEMPLATES.SINGLE_CHOICE_2, id: nextId(), title: '', subtitle: '', required: true, choices: []}],
    }),
    [constants.EDITOR_TEMPLATES.SINGLE_CHOICE_3]: (nextPageId, nextId, intl) => ({
        id: nextPageId(), preScripts: [], postScripts: [], optionsScripts: [], rowsScripts: [], terminal: false,
        items: [
            {
                type: constants.EDITOR_TEMPLATES.SINGLE_CHOICE_3, id: nextId(), title: '', subtitle: '', required: true, choices: [
                    {id: '1', value: intl.formatMessage(messages.likert.option.much)},
                    {id: '2', value: intl.formatMessage(messages.likert.option.enough)},
                    {id: '3', value: intl.formatMessage(messages.likert.option.notMuch)},
                    {id: '4', value: intl.formatMessage(messages.likert.option.none)},
                ],
            },
        ],
    }),
    [constants.EDITOR_TEMPLATES.SINGLE_CHOICE_4]: (nextPageId, nextId) => ({
        id: nextPageId(), preScripts: [], postScripts: [], optionsScripts: [], rowsScripts: [], terminal: false,
        items: [{type: constants.EDITOR_TEMPLATES.SINGLE_CHOICE_4, id: nextId(), title: '', subtitle: '', required: true, ratio: '0', choices: []}],
    }),
    [constants.EDITOR_TEMPLATES.SINGLE_CHOICE_1_EXT]: (nextPageId, nextId) => ({
        id: nextPageId(), preScripts: [], postScripts: [], optionsScripts: [], rowsScripts: [], terminal: false,
        items: [{type: constants.EDITOR_TEMPLATES.SINGLE_CHOICE_1_EXT, id: nextId(), title: '', subtitle: '', required: true, url: ''}],
    }),


    [constants.EDITOR_TEMPLATES.MULTIPLE_CHOICE_1]: (nextPageId, nextId) => ({
        id: nextPageId(), preScripts: [], postScripts: [], optionsScripts: [], rowsScripts: [], terminal: false,
        items: [{type: constants.EDITOR_TEMPLATES.MULTIPLE_CHOICE_1, id: nextId(), required: true, title: '', subtitle: '', min: '', max: '', choices: []}],
    }),
    [constants.EDITOR_TEMPLATES.MULTIPLE_CHOICE_2]: (nextPageId, nextId) => ({
        id: nextPageId(), preScripts: [], postScripts: [], optionsScripts: [], rowsScripts: [], terminal: false,
        items: [{type: constants.EDITOR_TEMPLATES.MULTIPLE_CHOICE_2, id: nextId(), required: true, title: '', subtitle: '', min: '', max: '', ratio: '0',
            choices: []}],
    }),


    [constants.EDITOR_TEMPLATES.BATTERY_1]: (nextPageId, nextId) => ({
        id: nextPageId(), preScripts: [], postScripts: [], optionsScripts: [], rowsScripts: [], terminal: false,
        items: [{type: constants.EDITOR_TEMPLATES.BATTERY_1, id: nextId(), title: '', subtitle: '', required: true, choices: [], rows: []}],
    }),
    [constants.EDITOR_TEMPLATES.BATTERY_2]: (nextPageId, nextId) => ({
        id: nextPageId(), preScripts: [], postScripts: [], optionsScripts: [], rowsScripts: [], terminal: false,
        items: [{type: constants.EDITOR_TEMPLATES.BATTERY_2, id: nextId(), title: '', subtitle: '', required: true, min: '', max: '', choices: [], rows: []}],
    }),


    [constants.EDITOR_TEMPLATES.DATE_1]: (nextPageId, nextId) => ({
        id: nextPageId(), preScripts: [], postScripts: [], optionsScripts: [], rowsScripts: [], terminal: false,
        items: [{type: constants.EDITOR_TEMPLATES.DATE_1, id: nextId(), title: '', subtitle: '', required: true, min: '', max: ''}],
    }),


    [constants.EDITOR_TEMPLATES.IMAGE_1]: (nextPageId, nextId) => ({
        id: nextPageId(), preScripts: [], postScripts: [], optionsScripts: [], rowsScripts: [], terminal: false,
        items: [{type: constants.EDITOR_TEMPLATES.IMAGE_1, id: nextId(), title: '', subtitle: '', required: true}],
    }),


    [constants.EDITOR_TEMPLATES.GEO_1]: (nextPageId, nextId) => ({
        id: nextPageId(), preScripts: [], postScripts: [], optionsScripts: [], rowsScripts: [], terminal: false,
        items: [{type: constants.EDITOR_TEMPLATES.GEO_1, id: nextId(), text: '', subtitle: '', required: true}],
    }),


    [constants.EDITOR_TEMPLATES.GENERATOR_CLASSIFIER]: (nextPageId, nextId) => ({
        id: nextPageId(), preScripts: [], postScripts: [], optionsScripts: [], rowsScripts: [], terminal: false,
        items: [{type: constants.EDITOR_TEMPLATES.GENERATOR_CLASSIFIER, id: nextId(), title: '', subtitle: '', source: '', choices: []}],
    }),


    [constants.EDITOR_TEMPLATES.RANK_1]: (nextPageId, nextId) => ({
        id: nextPageId(), preScripts: [], postScripts: [], optionsScripts: [], rowsScripts: [], terminal: false,
        items: [{type: constants.EDITOR_TEMPLATES.RANK_1, id: nextId(), title: '', subtitle: '', required: true, max: '', rows: []}],
    }),


    [constants.EDITOR_TEMPLATES.GENERATOR_CLASSIFIER_2]: (nextPageId, nextId) => ({
        id: nextPageId(), preScripts: [], postScripts: [], optionsScripts: [], rowsScripts: [], terminal: false,
        items: [{type: constants.EDITOR_TEMPLATES.GENERATOR_CLASSIFIER_2, id: nextId(), title: '', subtitle: '', source: '', choices: []}],
    }),
};

export default pageBuilders;
